Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaRoot = exports.getSchemaRootInstance = exports.isSchemaRoot = exports.compileSchema = exports.queryFieldsRegistry = exports.mutationFieldsRegistry = exports.schemaRootsRegistry = void 0;
var registry_1 = require("./registry");
Object.defineProperty(exports, "schemaRootsRegistry", { enumerable: true, get: function () { return registry_1.schemaRootsRegistry; } });
Object.defineProperty(exports, "mutationFieldsRegistry", { enumerable: true, get: function () { return registry_1.mutationFieldsRegistry; } });
Object.defineProperty(exports, "queryFieldsRegistry", { enumerable: true, get: function () { return registry_1.queryFieldsRegistry; } });
const registry_2 = require("./registry");
var compiler_1 = require("./compiler");
Object.defineProperty(exports, "compileSchema", { enumerable: true, get: function () { return compiler_1.compileSchema; } });
var services_1 = require("./services");
Object.defineProperty(exports, "isSchemaRoot", { enumerable: true, get: function () { return services_1.isSchemaRoot; } });
Object.defineProperty(exports, "getSchemaRootInstance", { enumerable: true, get: function () { return services_1.getSchemaRootInstance; } });
function SchemaRoot(config = {}) {
    return (target) => {
        registry_2.schemaRootsRegistry.set(target, config);
    };
}
exports.SchemaRoot = SchemaRoot;
//# sourceMappingURL=SchemaRoot.js.map